export default __webpack_public_path__ + "static/media/lunchFasting.c218d202.svg";